module.exports = __webpack_public_path__ + "img/catstile_transparent.8f1ef437.png";